<template>
  <div>
    <p>{{ time | secondsInMinutes }}</p>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "stopwatch",
  props: {
    running: {
      type: Boolean,
      default: false
    },
    resetWhenStart: {
      type: Boolean,
      default: false
    },
    restWhenStop: {
      type: Boolean,
      default: false
    },
    since: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      time: 0,
      timer: null,
      initialTime: 0
    };
  },
  computed: {
    name() {
      return this.data 
    }
  },
  watch: {
    running (val) {
      this.initialTime = new Date().getTime() - (this.since * 1000)
      if (val) this.startTimer();
      else this.stopTimer();
    }
  },
  mounted() {
    this.initialTime = new Date().getTime() - (this.since * 1000)
    this.setTime()
    if (this.running) this.startTimer();
    this.$emit('mounted')
  },
  destroyed () {
    this.stopTimer()
  },
  methods: {
    stopTimer () {
      clearInterval(this.timer);
      if (this.restWhenStop) this.resetTimer();
    },
    startTimer () {
      if (this.resetWhenStart) this.resetTimer();
      this.timer = setInterval(() => {
        this.setTime()
      }, 1000);
    },
    resetTimer () {
      this.time = 0;
    },
    setTime() {
      const delta = Date.now() - this.initialTime
      this.time = Math.floor(delta / 1000)
    },
    getTime () {
      return this.time
    }
  },
  filters: {
    secondsInMinutes (seconds) {
      return moment("2022-01-01")
        .startOf("day")
        .seconds(seconds)
        .format("HH:mm:ss");
    }
  }
};
</script>

<style scoped>
p {
  width: 100%;
  font-size: 30px;
  display: inline-block;
  clear: both;
  width: 100%;
  padding: 0px 2px;
  text-align: center;
  margin: 0;
  line-height: 1;
}
</style>
